import { Typography } from 'antd'

const SawitPoinLabel = ({ state }: { state: string }) => {
  switch (state) {
    case 'WAITING':
      return (
        <span className="bg-[#FCD102] py-2 inline-block mt-2 px-2 text-xs font-bold rounded-lg uppercase">
          MENUNGGU KONFIRMASI
        </span>
      )
    case 'APPROVED':
      return (
        <>
          <span className="bg-primary-700 py-2 inline-block mt-2 px-2 text-xs text-white font-bold rounded-lg uppercase">
            DIKONFIRMASI
          </span>
          <Typography className="text-xs text-gray-500 mt-2">17 Jan 2024, 10:34</Typography>
        </>
      )
    case 'REJECTED':
      return (
        <>
          <span className="bg-[#ff4d4d] py-2 inline-block mt-2 px-2 text-xs text-white font-bold rounded-lg uppercase">
            DITOLAK
          </span>
          <Typography className="text-xs text-gray-500 mt-2">17 Jan 2024, 10:34</Typography>
        </>
      )
    default:
      return (
        <span className="bg-[#FCD102] py-2 inline-block mt-2 px-2 text-xs font-bold rounded-lg uppercase">
          MENUNGGU KONFIRMASI
        </span>
      )
  }
}

export default SawitPoinLabel
